module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boxDiv"
  }, [_c('el-form', {
    staticClass: "elform",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "139px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "企业全称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入企业全称",
      "maxlength": "50"
    },
    model: {
      value: (_vm.Name),
      callback: function($$v) {
        _vm.Name = $$v
      },
      expression: "Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "联系人："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系人",
      "maxlength": "20"
    },
    model: {
      value: (_vm.Contacts),
      callback: function($$v) {
        _vm.Contacts = $$v
      },
      expression: "Contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "联系电话："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系电话",
      "maxlength": "11",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "blur": _vm.isblur
    },
    model: {
      value: (_vm.CPhone),
      callback: function($$v) {
        _vm.CPhone = $$v
      },
      expression: "CPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "统一社会应用代码："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入统一社会应用代码",
      "maxlength": "50"
    },
    model: {
      value: (_vm.UsaCode),
      callback: function($$v) {
        _vm.UsaCode = $$v
      },
      expression: "UsaCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "法定代表人："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法定代表人",
      "maxlength": "20"
    },
    model: {
      value: (_vm.Boss),
      callback: function($$v) {
        _vm.Boss = $$v
      },
      expression: "Boss"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "注册资本："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入注册资本",
      "maxlength": "8",
      "onkeyup": "value=value.replace(/[^\\d\\.]/g,'').replace('.','')"
    },
    on: {
      "blur": _vm.isblur
    },
    model: {
      value: (_vm.RCapital),
      callback: function($$v) {
        _vm.RCapital = $$v
      },
      expression: "RCapital"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "经营范围："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入经营范围",
      "maxlength": "50"
    },
    model: {
      value: (_vm.Scope),
      callback: function($$v) {
        _vm.Scope = $$v
      },
      expression: "Scope"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "企业规模："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.EScale),
      callback: function($$v) {
        _vm.EScale = $$v
      },
      expression: "EScale"
    }
  }, _vm._l((_vm.stautIdarr), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "注册地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入注册地址",
      "maxlength": "100"
    },
    model: {
      value: (_vm.RAddress),
      callback: function($$v) {
        _vm.RAddress = $$v
      },
      expression: "RAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "rules": [{
        required: true
      }],
      "prop": "",
      "label": "公司介绍："
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 6
      },
      "maxlength": "1000",
      "placeholder": "请输入公司介绍"
    },
    model: {
      value: (_vm.Introduction),
      callback: function($$v) {
        _vm.Introduction = $$v
      },
      expression: "Introduction"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "28%",
      "margin-top": "30px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.emit()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1dc350f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/extend.vue
// module id = 1649
// module chunks = 3